// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"7962":"home","9636":"landing"}[chunkId] || chunkId) + "-legacy." + {"304":"b545a7ae","1141":"ffb1b0ed","3231":"08050344","5053":"29f530f5","7327":"e24a8afe","7842":"33c06422","7962":"3ed3ae10","8037":"4bd6cc0d","8708":"c1e20995","8859":"05c74f9e","8982":"a4f925b9","9636":"a8e10666"}[chunkId] + ".js";
};